// refreshTokenMiddleware.js
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { store } from './store';
import { logout } from '../actions/user';
import ActionTypes from '../constants/ActionTypes';
import BASE_URL from "../constants/Api";

// Create an axios instance
const axiosInstance = axios.create();

// Request interceptor to add authorization header
axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem('accessToken');
    config.headers = config.headers || {};
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
}, error => Promise.reject(error));

// Function to check if token refresh is needed
const shouldRefreshToken = error => error.response?.status === 502;

// Logic to refresh token
const refreshAuthLogic = async failedRequest => {
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (!refreshToken) {
        handleLogout();
        return Promise.reject(new Error('No refresh token found'));
    }

    try {
        const response = await axios.post(`${BASE_URL}/users/refresh-token`, { refresh_token: refreshToken }, {
            headers: { Authorization: `Bearer ${refreshToken}` }
        });

        const { access_token, refresh_token, maintenance } = response.data.respons;
        if (maintenance === 1) {
            handleLogout();
            return Promise.reject(new Error('Maintenance'));
        }
        localStorage.setItem('accessToken', access_token);
        localStorage.setItem('refreshToken', refresh_token);
        store.dispatch({
            type: ActionTypes.REFRESH_ACCESS_TOKEN_SUCCESS,
            payload: { accessToken: access_token, refreshToken: refresh_token }
        });

        if (failedRequest.response?.config) {
            failedRequest.response.config.headers = failedRequest.response.config.headers || {};
            failedRequest.response.config.headers['Authorization'] = `Bearer ${access_token}`;
        }

        return Promise.resolve();
    } catch (error) {
        console.error('Failed to refresh token', error);
        handleLogout();
        return Promise.reject(error);
    }
};

// Function to handle logout
const handleLogout = () => {
    store.dispatch(logout());

    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    let companyId, loginId;

    if (rememberMe) {
        companyId = localStorage.getItem('companyId');
        loginId = localStorage.getItem('loginId');
    }

    localStorage.clear();

    if (rememberMe) {
        localStorage.setItem('rememberMe', 'true');
        if (companyId) localStorage.setItem('companyId', companyId);
        if (loginId) localStorage.setItem('loginId', loginId);
    }
    
    window.location.href = '/login';
};

// Attach refresh logic to axios instance
createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic, { shouldRefresh: shouldRefreshToken });

export default axiosInstance;
